import { reatomAsync, withAbort } from "@reatom/async";
import { CreateProductSelectionDto } from "definitions/product-storage";
import { API } from "src/api";

import { getProductSampleRequest } from "./getProductSampleRequest";

export const createProductSampleRequest = reatomAsync(
  async (ctx, data: CreateProductSelectionDto) => {
    return API.productSamplesApi
      .productSelectionControllerCreate(
        {
          createProductSelectionDto: {
            ...data,
            productIds: data.productIds ?? [],
          },
        },
        {
          signal: ctx.controller.signal,
        },
      )
      .then((res) => res.data);
  },
  {
    name: "createProductSampleRequest",
    onFulfill: (ctx, { id }) => {
      getProductSampleRequest(ctx, id);
    },
  },
).pipe(withAbort());
